// extracted by mini-css-extract-plugin
export default {"vacancy":"projectVacancy_vacancy__gjhb-"};